//当前登录账号的用户信息
export default {
    //开启命名空间
    namespaced: true,
    //state状态
    state: {
        //用户信息
        navbar: "home"
    },
    //mutations处理同步操作
    mutations: {
        SET_NAVBAR: (state, data) => {
            state.navbar = data;
        },
    },
    //actions 主要是异步操作
    actions: {

    }
};